export default {
  'rs-h1': () => import('./RsH1'),
  'rs-h2': () => import('./RsH2'),
  'rs-lazy-load': () => import('./RsLazyLoad')
}
